/* eslint-disable @typescript-eslint/no-unused-expressions */
import { leapApi as api } from "utilities/Axios";

export const getAllUnits = () => {
	return api.get("/TagMeta/GetAllUnits");
};

export const getUnitsByTrainId = (trainId = 0) => {
	return api.get(`/TagMeta/GetUnitsByTrainId?id=${trainId}`);
};

export const createUnit = (unit: any) => {
	return api.post("/TagMeta/CreateUnit", unit);
};

export const updateUnit = (unit: any) => {
	return api.post("/TagMeta/UpdateUnit", unit);
};

export const deleteUnit = (id: any) => {
	return api.get(`/TagMeta/DeleteUnit?id=${id}`);
};